import dayjs from 'dayjs'
import { toISOLocal } from './date'

/**
 * @param date 传入时间
 * 当前日历视图的开始日期
 */
export function startMonth(date?: string) {
  const startOfMonth = dayjs(date).startOf('month')
  const startDayOfWeek = startOfMonth.day()
  return startOfMonth.subtract(startDayOfWeek === 0 ? 6 : startDayOfWeek - 1, 'day')
}

/**
 * @param date 传入时间
 * 当前日历视图的结束日期
 */
export function endMonth(date?: string) {
  const endOfMonth = dayjs(date).endOf('month')
  const endDayOfWeek = endOfMonth.day()
  return endOfMonth.add(endDayOfWeek === 0 ? 1 : 7 - endDayOfWeek, 'day')
}

export function compareDate(date1:string,date2:string) {
  date1 = dayjs(date1).format('YYYY-MM-DD')
  date2 = dayjs(date2).format('YYYY-MM-DD')
  if (date1 === date2) {
    return true
  }
}

/**
 * 获取开始日期和结束日期范围内的所有日期
 * @param startTime 开始日期
 * @param endTime 结束日期
 */
export function getWeekDate(startTime:Date,endTime:Date) {
  const bd = new Date(startTime),be = new Date(endTime);
  const bdTime = bd.getTime(), beTime = be.getTime(),diff = beTime - bdTime;
  const arr = [];
  for(let i=0; i<= diff; i+=86400000){
    const ds = new Date(bdTime+i)
    const mounth = (new Date(ds).getMonth() + 1 < 10) ? '0' + (new Date(ds).getMonth() + 1) : (new Date(ds).getMonth() + 1)
    const day = (new Date(ds).getDate() < 10) ? '0' + new Date(ds).getDate() : new Date(ds).getDate()
    arr.push((ds.getFullYear())+'-'+ mounth +'-'+ day)
  }
  return arr
}


/**
 * 获取传入日期的开始时间（00:00:00）
 * @param start
 */
export function getTodayStartDay(start:Date) {
  const startOfDay = dayjs(start).startOf('day')
  return toISOLocal(startOfDay.toDate())
}

/**
 * 获取传入时间的结束时间（23:59:59)
 */
export function getTodayEndDay(end:Date) {
  const endOfDay = dayjs(end).endOf('day')
  return toISOLocal(endOfDay.toDate())
}
